import React from "react";
import clsx from "clsx";
import { Table, TableHead, TableBody, TableRow, TableCell } from "@curves/ui-base";
import SmartFitnessBandFeeBox from "@icoach/accountBook/components/SmartFitnessBandFeeBox";
import { formatCurrencyFn } from "@util/utils";

const SmartFitnessBandFeeItemRow = React.forwardRef((props, ref) => {
	const { sourceData } = props;

	return (
		<TableRow className={"cart-table-item fee-item"}>
			<TableCell>
				<SmartFitnessBandFeeBox className={"fee-item"} name={sourceData?.name || "智能系統月費"} />
			</TableCell>
			<TableCell />
			<TableCell colSpan={2}>${formatCurrencyFn(sourceData?.assignPrice || 0)}</TableCell>
		</TableRow>
	);
});

const SmartFitnessBandFeeTableHead = () => {
	return (
		<TableHead>
			<TableRow>
				<TableCell>品項</TableCell>
				<TableCell />
				<TableCell>價格</TableCell>
			</TableRow>
		</TableHead>
	);
};

const SmartFitnessBandFeeTable = React.forwardRef((props, ref) => {
	const { className, sourceData } = props;

	return (
		<Table className={clsx("cart-table", className)}>
			<SmartFitnessBandFeeTableHead />
			<TableBody>
				{sourceData.map((item, index) => (
					<SmartFitnessBandFeeItemRow key={`smart-fitness-band-fee-${index}`} sourceData={item} />
				))}
			</TableBody>
		</Table>
	);
});

export default SmartFitnessBandFeeTable;
